/**
 * @module plugins/vue-apexcharts
 * @description This plugin integrates the vue-apexcharts library into Nuxt. Currently it is unused, but should be useful in the future for creating charts.
 * @param {Object} nuxtApp - The Nuxt app instance.
 * @returns {void} This function does not have a return value, it only registers the VueApexCharts component.
 */

import VueApexCharts from 'vue-apexcharts'
import {defineNuxtPlugin} from 'nuxt/app'

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.component('apexchart', VueApexCharts)
})



